import { useMemo } from 'react';
import { AssessmentWrapper } from 'components/shared/styled';
import Score from './Score';
import TextButtonRight from './TextButtonRight';
import ImageTextLeft from './ImageTextLeft';
import Steps from './Steps';
import Testimonials from './Testimonials';
import TextButtonBottom from './TextButtonBottom';
import Family from './images/family.svg';
import { treatmentSubscription, treatments } from './constants/treatments';
import { steps } from './constants/steps';
import { quotes } from './constants/quotes';
import { IQuestion } from '../assessment-flow/types';
import { ADHD_ASSESSMENT_RESULT_CREATE_ACCOUNT_BUTTON } from '../shared/analytics/segment-events';

interface IAssessmentResultProps {
  data: string | null;
  segmentEventKey?: string;
}

const AssessmentResult = ({
  data,
  segmentEventKey = ADHD_ASSESSMENT_RESULT_CREATE_ACCOUNT_BUTTON
}: IAssessmentResultProps) => {
  const score = useMemo(() => {
    if (data) {
      const assessmentResult = JSON.parse(data) as IQuestion[];
      return assessmentResult.reduce(
        (result, question) => result + (question.selectedOption?.score || 0),
        0
      );
    }

    return 0;
  }, [data]);

  return (
    <AssessmentWrapper>
      <Score score={score} />
      <TextButtonRight
        title="Continue with basic info to see if treatment is right for you"
        description="The professionals at Cerebral can provide a medical evaluation and appropriate treatment options to help you take control of your mental health."
      />
      <ImageTextLeft
        image={Family}
        texts={treatments}
        subscription={treatmentSubscription}
      />
      <Steps steps={steps} segmentEventKey={segmentEventKey} />
      <Testimonials quotes={quotes} />
      <TextButtonBottom
        title="Get to a good place"
        description="Join Cerebral to get the professional support you need to live a happy, healthy, and productive life."
      />
    </AssessmentWrapper>
  );
};

export default AssessmentResult;
